import { deleteScheduleRepo } from "../../../data/repository/scheduled.repository";

export const DeleteScheduleUseCase = async (scheduled) => {
  try {
    const resp = await deleteScheduleRepo(scheduled);
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};
